import { useIntl } from 'react-intl';

export const useAttributeFormatter = () => {
  const intl = useIntl();

  const attributeFormatter: AttributeFormatter = (
    value: string | undefined,
    config?: { replaceEmptyString?: boolean }
  ) => {
    // config.replaceEmptyString can be used to only replace if input is empty string
    if (config && config.replaceEmptyString && value !== '') {
      return value;
    }
    if (typeof value === 'undefined' || value === null || value === '') {
      return `(${intl.formatMessage({ id: 'attribute.empty', defaultMessage: 'empty' })})`;
    }
    return value;
  };

  return { attributeFormatter };
};

export type AttributeFormatter = (
  value: string | undefined,
  config?: { replaceEmptyString?: boolean }
) => string | undefined;
